import React, { useState } from "react";
import { MadFragment } from "../../graphql/fragments";
import useTranslations from "../../hooks/useTranslations";
import { H4 } from "../wombat-ui";
import FollowUpContracts from "./FollowUpContracts";

type UserFollowUpContractsProps = {
  mad: MadFragment;
};

const UserFollowUpContracts: React.FC<UserFollowUpContractsProps> = ({
  mad,
}) => {
  const t = useTranslations();

  if (mad.template.contractTemplateIds.length === 0) {
    return null;
  }

  return (
    <div>
      <div className="flex items-center justify-between">
        <div>
          <H4>{t("mads.contracts")}</H4>
        </div>
      </div>
      <div className="grid gap-4 lg:grid-cols-4 xs:grid-cols-1 md:grid-cols-2">
        <FollowUpContracts mad={mad} />
      </div>
    </div>
  );
};

export default UserFollowUpContracts;
